import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './_nath_silva_fisiculturismo.module.scss';

const VIDEO_SRC = require('./src/fisioculturismo/video.MP4') as string;

/** Ordem natural 1–17 (evita sort alfabético 1, 10, 2…) */
const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/fisioculturismo/fisiculturismo_1.png'), label: '01' },
    { src: require('./src/fisioculturismo/fisiculturismo_2.png'), label: '02' },
    { src: require('./src/fisioculturismo/fisiculturismo_3.png'), label: '03' },
];

const _nath_silva_fisiculturismo: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles._nath_silva_fisiculturismo}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/_nath_silva"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao link na bio"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Nathalia Silva</p>
                        <h1 className={styles.title}>Fisiculturismo</h1>
                    </div>
                </div>

                <div className={styles.grid}>
                    <figure className={styles.card}>
                        <div className={styles.mediaInset}>
                            <div className={styles.portraitFrame}>
                                <video
                                    className={styles.portraitMedia}
                                    src={VIDEO_SRC}
                                    playsInline
                                    muted
                                    autoPlay
                                    loop
                                    preload="metadata"
                                    width={1080}
                                    height={1920}
                                >
                                    Seu navegador não suporta reprodução de vídeo.
                                </video>
                            </div>
                        </div>
                        <figcaption className={styles.cardFigcaption}>Vídeo</figcaption>
                    </figure>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <div className={styles.mediaInset}>
                                <div className={styles.portraitFrame}>
                                    <img
                                        src={item.src}
                                        alt={`Fisiculturismo — Nathalia Silva, imagem ${item.label}`}
                                        className={styles.portraitMedia}
                                        loading={index < 2 ? 'eager' : 'lazy'}
                                    />
                                </div>
                            </div>
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default _nath_silva_fisiculturismo;
